// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__pS7N5","content":"Dashboard_content__KZbNG","main":"Dashboard_main__jg9Lx"};